import React from 'react';

export const ProcessCard = ({ process, delay }) => {
  return (
    <div className="pcard">
      <div className="pnum">{process.n}</div>
      <div className="ptitle">{process.title}</div>
      <div className="pbody">{process.body}</div>
    </div>
  );
};